import { level3, secondaryNavigation } from "../../models/primary-menu-model";

const DropdownMenu = (props: { links: level3[], callout: secondaryNavigation }) => {

  const { links, callout } = props;
  const handleEmptyClick = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    event.preventDefault();
  }

  return <div className="dropdown-content dropdown-menu">
    <div className="d-flex justify-content-between">
      <div className="mega-menu-column col-md">
        {links.map((item, index) => {
          return (index % 2 === 0) ? <a href={item.page} key={index} className="nav-link">{item.name}</a> : ''
        })}
        {(links.length < 5) ?
          <span style={{ textDecoration: "none", cursor: "default" }} onClick={handleEmptyClick}>&nbsp;</span> : ''}
      </div>
      <div className="mega-menu-column col-md">
        {links.map((item, index) => {
          return (index % 2 === 1) ? <a href={item.page} key={index} className="nav-link">{item.name}</a> : ''
        })}
        {(links.length % 2 === 1 || (links.length <= 5)) ?
          <span style={{ textDecoration: "none", cursor: "default" }} onClick={handleEmptyClick}>&nbsp;</span> : ''}
      </div>

      {(callout.summary) ? (
        <div className="mega-menu-callout">
          <div className="alert alert-info mb-0" style={{ height: "100%" }}>
            <div className="row">
              <div className="col-md">
                <h4 className="alert-heading fw-bold" dangerouslySetInnerHTML={{ __html: callout.title }}></h4>
                <p className="lead mb-0">{callout.summary}</p>
              </div>
              <div className="col-md-5">
                <a href={callout.linkUrl}><img alt={callout.title} src={callout.image} /></a>
              </div>
            </div>
            <hr />
            <a href={callout.linkUrl} className="btn btn-lg btn-primary mt-2">{callout.linkText}</a>
          </div>
        </div>
      ) : ''}
    </div>
  </div>
}

export default DropdownMenu;